import React from "react";
import { ReactComponent as AppStore } from "../../../Assets/appStore.svg";
import { ReactComponent as GooglePlay } from "../../../Assets/googlePlay.svg";
import FindTribeImg from "../../../Assets/findTribeImg.svg";
import "./style.scss";
const FindYourTribe = () => {
  return (
    <div className="staticContent findYourTribe flex">
      <div className="content">
        <img
          src={FindTribeImg}
          alt="tribe-img"
          className="find-your-tribe-image-mobile"
          width="72px"
        />

        <p className="subtitle">Unpause the fun. Download Student Tribe.</p>
        <h1>Dive into Your Vibe. Find Your Tribe.</h1>
        <p className="find-your-tribe-description">
          Experience live music, comedy, workshops, sports, and more! Discover
          new hobbies, groove to your favorite artists, and make friends who
          share your passions. Don't wait, download the Student Tribe app today!
        </p>
        <div className="link-icons">
          <a
            href="https://apps.apple.com/us/app/student-tribe/id1362552730"
            target="_blank"
            rel="noreferrer"
          >
            <AppStore />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.tdevelopers.stumagz"
            target="_blank"
            rel="noreferrer"
          >
            <GooglePlay />
          </a>
        </div>
      </div>
      <img
        src={FindTribeImg}
        alt="tribe-img"
        className="find-your-tribe-image-desktop"
        width="220px"
      />
    </div>
  );
};

export default FindYourTribe;
